const calpak = window.calpak

function productUnitUpdateHover(option, productTitle, productImageContainer, sizes) {

  // productImageContainer.querySelector("picture source").setAttribute("srcset", calpak.lazyloadImageSrcset(img, [400], true));
  // productImageContainer.querySelector("picture img").setAttribute("alt", option.getAttribute("data-alt"));
  // sizes = productImageContainer.querySelector("picture source").getAttribute("sizes");

  let hoverImg = productImageContainer.querySelector(".img-hover");
  if (option.hasAttribute("data-hover")) {
    const hover = option.getAttribute("data-hover");

    if (hover) {
      if (hoverImg){
        let imageAlt = option.getAttribute("data-alt");
        hoverImg.querySelector("source").setAttribute("srcset", calpak.lazyloadImageSrcset(hover, [400], true))
        hoverImg.querySelector("img").setAttribute("srcset", calpak.lazyloadImageSrcset(hover, [400]))
        hoverImg.querySelector("img").setAttribute("alt",  `${imageAlt? imageAlt : productTitle} view 2`);

        
        if(productImageContainer.classList.contains("stop-gif") && hover.includes(".gif")){
          let canvasElement = hoverImg.querySelector("canvas");
          if(!canvasElement)
            canvasElement = document.createElement("canvas");
          canvasElement.style.width = "100%";
          canvasElement.style.height = "100%";
          hoverImg.appendChild(canvasElement);
          const ctx = canvasElement.getContext('2d');
          const img = hoverImg.querySelector("img");
          img.onload = function () {
            // Draw the first frame on the canvas
            setTimeout(() => {
              ctx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
              img.style.display = 'none';  // Hide the GIF
            }, 500);
          };
        }


      } else {
        // hoverImg = document.createElement("img");
        // hoverImg.setAttribute("src", hover);
        // if (sizes != null){
        //   hoverImg.setAttribute("sizes", sizes);
        // }
        // hoverImg.setAttribute("srcset", calpak.lazyloadImageSrcset(hover, [400]));
        // hoverImg.setAttribute("alt",  option.getAttribute("data-alt"))
        // hoverImg.classList.add("img-hover");
        // hoverImg.setAttribute("loading", "eager");
        // productImageContainer.appendChild(hoverImg);
      }
    } else if (hoverImg) hoverImg.remove();
  } else if (hoverImg) hoverImg.remove();
}
calpak.productUnitUpdateHover = productUnitUpdateHover

function updateProductURLs(
  productContainer,
  options,
  multiple = false,
  earlyAccess = false,
  optionswithoos,
  hasSizeSelector
) {
  const handle = productContainer.getAttribute("data-handle");
  let url = `/products/${handle}/${earlyAccess ? "early-access-" : ""}`;
  const productLinks = productContainer.querySelectorAll(
    ".product-link, .quick-view__link"
  );
  if (productLinks.length > 0 && hasSizeSelector) multiple = true;
  url = multiple ? url + optionswithoos.join(",") : url + options[0];

  productLinks.forEach((productLink) => {
    productLink.setAttribute("href", url);
  });

  // update sign in to buy links
  const signInToBuyLinks = productContainer.querySelectorAll(
    "a[href^=\"/account/login?return_url=\"]"
  );

  signInToBuyLinks.forEach((signInToBuyLink) => {
    signInToBuyLink.setAttribute("href", `#login`);
  });
}

function handlePreorderLabels(productContainer, option, location) {
  let preorderLabels = productContainer.querySelectorAll(
    ".product-label--preorder"
  );
  preorderLabels.forEach((preorderLabel) =>
    preorderLabel.classList.remove("product-label--active")
  );

  if (option.getAttribute("data-available") != "false") {
    let preorder = false;
    if (option.hasAttribute("data-preorder"))
      preorder = option.getAttribute("data-preorder");

    if (preorder) {
      if (location == "pdp")
        productContainer
          .closest(".pdp__grid, .qv__body")
          .setAttribute("data-status", "preorder");

      preorderLabels.forEach((preorderLabel) => {
        preorderLabel.classList.add("product-label--active");
        preorderLabel.querySelector(".preorder-date").innerHTML = preorder;
      });
    } else if (location == "pdp")
      productContainer
        .closest(".pdp__grid, .qv__body")
        .setAttribute("data-status", "default");
  }
}

const variantUpdateProcess = function(target) {
  if (window.location.pathname.includes("/products/")) {
    if(typeof changeBadgeAbsolutePosition != "undefined")
      changeBadgeAbsolutePosition(); // defined on pdp.js
  }
  const productContainer = target.closest(
    ".product-unit, .shopify-product-form"
  );

  if (!productContainer) return;

  const select = productContainer.querySelector(".variant-select");
  
  if (!select) return;

  const hasSizeSelector = productContainer.querySelector(".product-unit__sizes")
    ? true
    : false;
  let location = false;
  if (productContainer.classList.contains("product-unit")) location = "unit";
  else if (productContainer.classList.contains("shopify-product-form"))
    location = "pdp";

  let [options, multiple] = getProductOptionsList(productContainer, location);
  let [optionswithoos, multiples] = getProductOptionsList(
    productContainer,
    location
  );
  let option = false,
    selector = `option`;
  let optionoos = false,
    selectors = `option`;
  if (location == "unit" && options.length > 1) {
    if (hasSizeSelector) {
      const optionSize = productContainer.querySelector(
        ".product-unit__sizes .size-swatch.selected"
      )?.dataset?.title;
      selector += `[data-option1="${options[0]}"][data-option2="${optionSize}"]`;
      selectors += `[data-option1="${options[0]}"][data-option2="${optionSize}"]`;
    } else {
      selector += `[data-option1="${options[0]}"]`;
      selectors += `[data-option1="${options[0]}"]`;
    }
    option = select.querySelector(selector + '[data-available="true"]');
    optionoos = select.querySelector(selectors);
    if (!option) {
      option = select.querySelector(selector);
    } else {
      options[1] = option.getAttribute("data-option2");
    }

    if (!optionoos) {
      optionoos = select.querySelector(selectors);
    } else {
      optionswithoos[1] = optionoos.getAttribute("data-option2");
    }
  } else {
    for (let i = 0; i < options.length; i++)
      selector += `[data-option${i + 1}="${options[i]}"]`;
    option = select.querySelector(selector);
    optionoos = select.querySelector(selector);
  }
  if (!option) return;
  select.value = option.value;

  const earlyAccessValue = productContainer.getAttribute("data-early-access");
  if(location != "pdp")
  updateProductURLs(
    productContainer,
    options,
    multiple,
    earlyAccessValue == "all" || earlyAccessValue == "only",
    optionswithoos,
    hasSizeSelector
  );

  if (location == "pdp")
    calpak.updateOptionsAvailability(options, select, productContainer);

  let price = option.getAttribute("data-price");
  let cprice = false;
  if (option.hasAttribute("data-cprice"))
    cprice = option.getAttribute("data-cprice");
  let formatedPrice = `<span class="sr-only">Current price: </span><b>${formatPrice(price / 100)}</b>`;
  if (option.closest(".pdp-gwp__inner")) {
    formatedPrice = `<span class="sr-only">Current price: </span><s>${formatPrice(price / 100)}</s>`;
  }
  if (cprice)
    formatedPrice = `<span class="sr-only">Original price: </span><s>${formatPrice(cprice / 100)}</s>` + formatedPrice;

  if(!cprice){
    formatedPrice = `<span class="sr-only">Original price: </span><b>${formatPrice(price / 100)}</b>`;
  }

  // const flashSaleDiscountMessage = productContainer.querySelector(".flash-sale-discount-message");
  // if(flashSaleDiscountMessage){
  //   const discountPrice = (Math.floor(price / 100 * flashSaleDiscountMessage.dataset.percent) / 100).toFixed(2);
  //   const discountedPrice = formatPrice(price / 100 - Number.parseFloat(discountPrice));
  //   const highlightDiscount = flashSaleDiscountMessage.dataset.highlightCode;
  //   let discountCode = flashSaleDiscountMessage.dataset.code;
  //   if(highlightDiscount == "true")
  //     discountCode = `<span class="highlight">${discountCode}</span>`;
  //   let message = "";
  //   if(flashSaleDiscountMessage.dataset.code != "")
  //     message = `${discountedPrice} with Code ${flashSaleDiscountMessage.dataset.code}`;
  //   else
  //   {
  //       message = `${discountedPrice}`;
  //   }
  //   if(flashSaleDiscountMessage.querySelector("span.message"))
  //     flashSaleDiscountMessage.querySelector("span.message").innerHTML = message
  // }
 
  const optionalLabels = productContainer
    .closest(".product-unit, .pdp__grid, .qv__body")
    .querySelectorAll(".product-label[data-options]");
  var productimagewrapper;
  if (
    productContainer
      .closest(".product-unit")
      ?.querySelector(".product-unit__image-wrapper")
  ) {
    productimagewrapper = productContainer
      .closest(".product-unit")
      .querySelector(".product-unit__image-wrapper");
  }

  optionalLabels.forEach((optionalLabel) => {
    if (
      optionalLabel.matches(`[data-options~="${options[0]}"]`) ||
      optionalLabel.matches(`[data-options~="${option.value}"]`)
    ) {
      optionalLabel.classList.add("product-label--active");
      if (productimagewrapper) {
        productimagewrapper.classList.add("border-add-active");
      }

      if (optionalLabel.classList.contains("product-label--badge")) {
        optionalLabel.classList.add("badge-active");
      }

      if (optionalLabel.classList.contains("product-label--extra-sale")) {
        productContainer
          .closest(".product-unit, .pdp__info, .qv__body")
          .classList.add("extra-sale-active");
      }
    } else {
      optionalLabel.classList.remove("product-label--active");
      if (productimagewrapper) {
        productimagewrapper.classList.remove("border-add-active");
      }
      if (optionalLabel.classList.contains("product-label--badge")) {
        optionalLabel.classList.remove("badge-active");
      }

      if (optionalLabel.classList.contains("product-label--extra-sale")) {
        productContainer
          .closest(".product-unit, .pdp__info, .qv__body")
          .classList.remove("extra-sale-active");
      }
    }
  });

  handlePreorderLabels(productContainer, option, location);

  if (location == "unit") {
    const img = option.getAttribute("data-image");

    if (option.getAttribute("data-available") == "false") {
      productContainer.classList.add("product-unit--na");
      if (
        option.getAttribute(`data-soldout-all-variants`) === true ||
        option.getAttribute(`data-soldout-this-variant`) === true
      ) {
        productContainer.classList.add("product-unit--so");
      } else {
        productContainer.classList.add("product-unit--jw");
      }
    } else {
      productContainer.classList.remove("product-unit--na");
      productContainer.classList.remove("product-unit--so");
      productContainer.classList.remove("product-unit--jw");
    }

    // TODO
    productContainer.querySelectorAll(".product-unit__price")?.forEach((priceElement) => {
      priceElement.innerHTML = formatedPrice;
    });

    const pdpDscnts = productContainer.querySelectorAll(".dscnt");
    if (cprice) {
      let discount = Math.floor(((cprice - price) * 100) / cprice);
      pdpDscnts.forEach((pdpDscnt) => {
        pdpDscnt.parentNode.classList.remove("product-label--hidden");
        if (pdpDscnt.dataset.priceDiscount == 'true') {
          const priceDiscount = Math.floor((cprice - price) / 100);
          pdpDscnt.innerHTML = `$${priceDiscount}`;
        } else {
          pdpDscnt.innerHTML = `${discount}%`;
        }
      });
    } else
      pdpDscnts.forEach((pdpDscnt) =>
        pdpDscnt.parentNode.classList.add("product-label--hidden")
      );

    
      const pdpMonochromeBadges = productContainer.querySelectorAll(".product-label--monochrome");
      pdpMonochromeBadges.forEach((badge) => {
        if(badge.dataset.monochromeVariants.indexOf(option.dataset.option1) != -1){
          badge.classList.remove("product-label--hidden");
          badge.classList.remove("product-label--na");
          badge.dataset.color = option.dataset.option1;
          return;
        }
        else{
          badge.classList.add("product-label--hidden");
          badge.classList.add("product-label--na");
        }
      });

    if (productContainer.classList.contains("adding-to-cart"))
      productContainer.classList.remove("adding-to-cart");
    if (productContainer.classList.contains("added-to-cart"))
      productContainer.classList.remove("added-to-cart");

    const productImageContainer = productContainer.querySelector(
      ".product-unit__image"
    );

    let sizes = "50vw";
    let productTitle = productContainer.querySelector('.product-unit__title .product-link')?.innerText;
    let imageAlt = option.getAttribute("data-alt");
    if (img) {
      productImageContainer.querySelector("picture source").setAttribute("srcset", calpak.lazyloadImageSrcset(img, [400], true));
      productImageContainer.querySelector("picture img").setAttribute("alt", `${imageAlt? imageAlt : productTitle} view 1`);
      sizes = productImageContainer.querySelector("picture source").getAttribute("sizes");

      if(productImageContainer.classList.contains("stop-gif") && img.includes(".gif")){
        let canvasElement = productImageContainer.querySelector("canvas");
        if(!canvasElement)
          canvasElement = document.createElement("canvas");
        canvasElement.style.width = "100%";
        canvasElement.style.height = "100%";
        productImageContainer.querySelector("picture").appendChild(canvasElement);
        const ctx = canvasElement.getContext('2d');
        const img = productImageContainer.querySelector("picture img");
        img.onload = function () {
          // Draw the first frame on the canvas
          setTimeout(() => {
            ctx.drawImage(img, 0, 0, canvasElement.width, canvasElement.height);
            img.style.display = 'none';  // Hide the GIF
          }, 200);
        };
      }

    }

    productUnitUpdateHover(option, productTitle, productImageContainer, sizes);

  } else if (location == "pdp") {
    const pdpInfo = productContainer.closest(".pdp__info, .qv__product");
    const pdpGrid = productContainer.closest(".pdp__grid, .qv__body");
    const isQuickView = pdpGrid.classList.contains("qv__body");

    const ytPoints = pdpGrid.querySelectorAll(".yt-points");
    ytPoints.forEach(
      (ytPoint) => (ytPoint.innerHTML = Math.floor(price / 100))
    );

    if (option.getAttribute("data-available") == "false") {
      pdpGrid.setAttribute("data-status", "sold-out");

      const waitlist = pdpGrid.querySelector(".pdp__waitlist--success");
      if (waitlist) waitlist.classList.remove("pdp__waitlist--success");

      if (pdpGrid.hasAttribute("data-soldout")) {
        if (pdpGrid.matches(`[data-soldout~=${options[0]}]`))
          pdpGrid.classList.add("pdp__grid--soldout");
        else pdpGrid.classList.remove("pdp__grid--soldout");
      }
    }

    const qty = option.getAttribute("data-qty");
    const stock = pdpInfo.querySelector(".pdp__stock");
    if (qty > 0 && qty <= 10) {
      stock.querySelector("span").innerHTML = qty;
      stock.classList.add("pdp__stock--active");
    } else stock.classList.remove("pdp__stock--active");

    if (price * 1 <= 5000)
    {
      if(pdpInfo.querySelector(".pdp__payments") != null)
        pdpInfo
          .querySelector(".pdp__payments")
          .classList.add("pdp__payments--limit");
    }
    else{
      
      if(pdpInfo.querySelector(".pdp__payments") != null)
        pdpInfo
          .querySelector(".pdp__payments")
          .classList.remove("pdp__payments--limit");
    }
    if(pdpInfo.querySelector(".pdp__payments-amnt") != null)
      pdpInfo.querySelector(".pdp__payments-amnt").innerHTML = formatPrice(
        price / 4 / 100
      );

    const pdpPrices = pdpInfo.querySelectorAll(
      ".pdp__price-inner, .pdp__submit-price"
    );
    pdpPrices.forEach((pdpPrice) => (pdpPrice.innerHTML = formatedPrice));
    
    if(productContainer.querySelector(".pdp__variants--price") != null){
      if(productContainer.querySelector(".product-option.product-option--selected")){
        const sizeValue = productContainer.querySelector(".product-option.product-option--selected").dataset.value;
        const sizeOptionPos = productContainer.querySelector(".product-option.product-option--selected").closest("[data-position]").dataset.position;
        productContainer.querySelectorAll(".pdp__swatches-group").forEach(group => {
          const colorSwatch = group.querySelector(".color-swatch.color-swatch--active") || group.querySelector(".color-swatch");
          const colorValue = colorSwatch.dataset.value;
          const colorOptionPos = group.closest("[data-position]").dataset.position;
          const option = select.querySelector(`option[data-option${colorOptionPos}="${colorValue}"][data-option${sizeOptionPos}="${sizeValue}"]`);
          if(option != null){
            let price = option.getAttribute("data-price");
            let cprice = false;
            if (option.hasAttribute("data-cprice"))
              cprice = option.getAttribute("data-cprice");
            let formatedPrice = `<span class="sr-only">Current price: </span><b>${formatPrice(price / 100).trim()}</b>`;
            if (cprice)
              formatedPrice = `<span class="sr-only">Original price: </span><s>${formatPrice(cprice / 100).trim()}</s>` + formatedPrice;
            if(!cprice){
              formatedPrice = `<span class="sr-only">Original price: </span><b>${formatPrice(price / 100).trim()}</b>`;
            }
            if(group.querySelector(".pdp-swatches-price-pricing")) {
              const pricingElement = group.querySelector(".pdp-swatches-price-pricing");
              const saleBadge = pricingElement.querySelector(".sale-badge");
              const saleBadgeHTML = saleBadge ? saleBadge.outerHTML : "";
              pricingElement.innerHTML = formatedPrice + saleBadgeHTML;
            }
          }
        });
      }
      else {
        if(target.closest(".pdp__swatches-group") && target.closest(".pdp__swatches-group").querySelector(".pdp-swatches-price-pricing")) {
          const pricingElement = target.closest(".pdp__swatches-group").querySelector(".pdp-swatches-price-pricing");
          const saleBadge = pricingElement.querySelector(".sale-badge");
          const saleBadgeHTML = saleBadge ? saleBadge.outerHTML : "";
          pricingElement.innerHTML = formatedPrice + saleBadgeHTML;
        }
      }
    }

    const locationContainers = document.querySelectorAll("section.pdp__free-shipping-text")
    locationContainers.forEach(async (locationContainer) => {
      if (option.getAttribute("data-available") == "true") {
        const shippingPrice = parseInt(locationContainer?.dataset?.shippingPrice);
        const locationAvailable = locationContainer?.dataset?.locationAvailable;
        if (locationContainer && locationAvailable == "true") {
          if (parseInt(price) >= shippingPrice) {
            locationContainer.style.display = "block";
          } else {
            locationContainer.style.display = "none";
          }
        } else if (locationContainer) {
          locationContainer.style.display = "none";
        }
      } else if (locationContainer) {
        locationContainer.style.display = "none";
      }
    })

    const pdpDscnts = pdpGrid.querySelectorAll(".dscnt");
    if (cprice) {
      let discount = Math.floor(((cprice - price) * 100) / cprice);
      pdpDscnts.forEach((pdpDscnt) => {
        pdpDscnt.parentNode.classList.remove("product-label--hidden");
        if (pdpDscnt.dataset.priceDiscount == 'true') {
          const priceDiscount = Math.floor((cprice - price) / 100);
          pdpDscnt.innerHTML = `$${priceDiscount}`;
        } else {
          pdpDscnt.innerHTML = `${discount}%`;
        }
      });
    } else
      pdpDscnts.forEach((pdpDscnt) => {
        pdpDscnt.parentNode.classList.add("product-label--hidden");
      });

      
    const pdpMonochromeBadges = pdpGrid.querySelectorAll(".product-label--monochrome");
    pdpMonochromeBadges.forEach((badge) => {
      if(badge.dataset.monochromeVariants.indexOf(option.dataset.option1) != -1){
        badge.classList.remove("product-label--hidden");
        badge.classList.remove("product-label--na");
        badge.dataset.color = option.dataset.option1;
        return;
      }
      else{
        badge.classList.add("product-label--hidden");
        badge.classList.add("product-label--na");
      }
    });

    calpak.pdpGalleryUpdate(pdpGrid, option, isQuickView);
    calpak.pdpSizePriceUpdate(option);

    //Extend - dispatch variandChange event for quickview and pdp
    if (isQuickView) {
      const event = new CustomEvent('variantChangedQuickView', { detail: { option: option.getAttribute('value') } });
      window.dispatchEvent(event);
    } else {
      const event = new CustomEvent('variantChanged', { detail: { option: option.getAttribute('value') } });
      window.dispatchEvent(event);
    }
    //Extend — end code
    
    let productLabelGiftGamification = null;
    if(isQuickView)
      productLabelGiftGamification = pdpGrid.querySelector(".product-label--gift-gamification");
    else
      productLabelGiftGamification = productContainer.querySelector(".product-label--gift-gamification");
    if(typeof productLabelGiftGamification != null)
    {
      const pdp_promo_text = window.holidayGamificationData?.pdp_promo_text;
      const pdp_promo_text_non = window.holidayGamificationData?.pdp_promo_text_non;
      const product_eligible_message = window.holidayGamificationData?.product_eligible_message;
      const product_non_eligible_message = window.holidayGamificationData?.product_non_eligible_message;

      if (typeof pdp_promo_text != "undefined"){
        const goal_price = Number(window.holidayGamificationData?.goal_price ?? 0) * 100;
        const price = Number(option.dataset.price);
        if(price >= goal_price){
          productLabelGiftGamification.querySelector("strong").innerHTML = pdp_promo_text;
          productLabelGiftGamification.querySelector("span").innerHTML = product_eligible_message;
        }else{
          productLabelGiftGamification.querySelector("strong").innerHTML = pdp_promo_text_non;
          productLabelGiftGamification.querySelector("span").innerHTML = product_non_eligible_message;
        }
        productLabelGiftGamification.style.display = "flex";
      }
    }

    if (!isQuickView) {
    //  calpak.pdpHandleUpsell(option);
   //   calpak.pdpHandleBundle(option);
      calpak.matchBundleSwatchesToOption(option);
      calpak.pdpHandleDescriptions(pdpInfo, option);
      calpak.productNewBadges(target, ".pdp__grid");
    //  calpak.pdpHandleFeaturedCollection(option);
    //   calpak.comingSoonBadge(target, ".pdp__grid");
      //  calpak.pdpHandleFeaturedCollection(option);
      calpak.pdpUpdateURL(product, options);
    }
    // disable california check for now calpak.userRegionCode === "CA"
    if (calpak.userRegionCode === "OFFLINE") {
      const sku = target.getAttribute("data-sku");
      if (calpak.hideSkusCalifornia?.includes(sku?.toUpperCase())) {
        const pdpGrid = target.closest(".pdp__grid");
        const quickView = target.closest(".qv__body");
        if (pdpGrid) {
          pdpGrid.setAttribute("data-status", "sold-out");
          target.classList.add("product-option--na");
        }
        if(quickView){
          quickView.setAttribute("data-status", "sold-out");
          target.classList.add("product-option--na");
        }
      }
    }
  }

  calpak.checkReducedMotionPauseGIFs()

}
calpak.variantUpdateProcess = variantUpdateProcess

